import { j as r } from "../../_virtual/jsx-runtime2.js";
import { __require as i } from "./cjs/react-jsx-runtime.production.min.js";
import { __require as o } from "./cjs/react-jsx-runtime.development.js";
(function(e) {
  process.env.NODE_ENV === "production" ? e.exports = i() : e.exports = o();
})(r);
//# sourceMappingURL=jsx-runtime.js.map
